<template>
  <el-container class="vulnerability-information">
    <el-container class="main-container">
      <el-main
        class="main-content"
        v-loading="loading"
      >
        <div class="content-header">
          <img src="@assets/codeScan/code_scan_sj.png" />
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ name:'ReportsIndex' }">{{ $t('vulnerabilityInformation.reports') }}</el-breadcrumb-item>
            <el-breadcrumb-item>
              <span
                style="cursor: pointer;font-weight: 700; color: #303133"
                @click="handleBack"
              >{{ projectName || '--' }}</span></el-breadcrumb-item>
            <el-breadcrumb-item>{{ $t('vulnerabilityInformation.details') }}</el-breadcrumb-item>
          </el-breadcrumb>
          <el-button
            style="margin-left: auto;"
            size="mini"
            @click="handleBack"
          > <i class="el-icon-back"></i> {{ $t('vulnerabilityInformation.back') }}</el-button>
        </div>
        <VulInfo :vul="detail">
          <div
            class="description-header"
            slot="header"
          >
            <h1>{{ $t('vulnerabilityInformation.detailedDescription') }}</h1>
          </div>
        </VulInfo>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { getVulDetail } from '@/api/base';
import VulInfo from '@/components/vul-info';

export default {
  name: 'ReportsView',
  components: {
    VulInfo,
  },
  data() {
    return {
      projectName: this.$route.query.projectName || '',
      detail: {},
      loading: true,
    };
  },
  watch: {
    '$route.query': {
      handler(newQuery) {
        this.projectName = newQuery.projectName || '';
      },
      deep: true,
    },
  },
  mounted() {
    this.projectName = this.$route.query.projectName;
    this.getDetail();
  },
  methods: {
    handleBack() {
      this.$router.back();
    },
    getDetail() {
      const { taskId, vulId } = this.$route.query;
      getVulDetail(taskId, vulId)
        .then((data) => {
          this.detail = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.vulnerability-information {
  width: 100%;
  display: flex;

  .export-dropdown {
    margin-left: auto;
  }

  .main-container {
    display: flex;
    flex-direction: column;
    width: calc(100% - 80px);
  }

  .sidebar {
    height: calc(100vh - 85px);
    margin: 50px 0px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
  }

  .el-menu {
    background: linear-gradient(to bottom, #e9eef2, #fff);
    height: calc(100vh - 85px);
    border-radius: 10px;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background-color: #fff;
    margin: 0;
    border-radius: 10px;
    width: 100%;
    position: absolute;
    top: 0px;
    right: 0px;
  }

  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .main-content {
    flex: 1;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .logo {
    width: 150px;
  }

  .user-info {
    display: flex;
    align-items: center;
  }

  .username {
    margin-right: 30px;
  }

  .user-icon {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    position: relative;
    right: 10px;
  }

  .content-header {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 15px;
    background-color: #e1e8ed;
    border-radius: 10px;
    padding: 0px 20px;
    height: 55px;
    line-height: 54px;

    img {
      position: relative;
      top: 0;
    }

    h2 {
      font-size: 20px;
    }

    .el-breadcrumb {
      font-size: 17px;
      margin: 0px 15px;
    }

    .el-dropdown-link {
      background-color: #fff;
      border-color: #101010;
      color: #000000;
      height: 30px;
      padding: 5px 20px;
    }
  }
}
</style>